export default __webpack_public_path__ + "static/media/alien.c8a26e39.gif";